module.exports = __webpack_public_path__ + "static/img/touxi3.3068a091.webp";